
<template>
    <div class="vheight comprehensiveList">
        <div class="container-boot" style="padding-right: 10px;padding-left: 10px;">
            <div class="panel-title" >
                <div class="panel-type"  :class="{ active: objType == '1' }" @click="handleTitle(1)">
                    <div class="icon">
                        <i class="el-icon-office-building"></i>
                    </div>
                    <span class="title">物业企业</span>
                </div>
                <div class="panel-type" :class="{ active: objType == '2'  }" @click="handleTitle(2)">
                    <div class="icon">
                        <i class="el-icon-user"></i>
                    </div>
                    <span class="title">项目负责人</span>
                </div>
                <div class="panel-type" :class="{ active: objType == '3'  }" @click="handleTitle(3)">
                    <div class="icon">
                        <i class="el-icon-set-up"></i>
                    </div>
                    <span class="title">业委会成员</span>
                </div>
                <!-- <div class="panel-type" :class="{ active: objType == '4'  }" @click="handleTitle(4)">
                    <div class="icon">
                        <i class="el-icon-coffee"></i>
                    </div>
                    <span class="title">业主</span>
                </div> -->
                <div class="panel-type" :class="{ active: objType == '5'  }"  @click="handleTitle(5)">
                    <div class="icon">
                        <i class="el-icon-coffee"></i>
                    </div>
                    <span class="title">业委会执行秘书</span>
                </div>
              <div class="panel-type" :class="{ active: objType == '6'  }"  @click="handleTitle(6)">
                <div class="icon">
                  <i class="el-icon-coffee"></i>
                </div>
                <span class="title">业主监事（会）</span>
              </div>
            </div>
            <div class="components-box">
                <template v-if="columnLabel == '满意度得分' || columnLabel == '满意度排名' || columnLabel == '反馈率'">
                    <satisfaction
                        :code='code'
                        :eaAreaCode='eaAreaCode'
                        :columnLabel='columnLabel'
                        :objType='objType'
                    ></satisfaction>
                </template>
                <template v-else-if="columnLabel == '共有资金账户' || columnLabel == '登记共有资金账户'">
                    <account-register
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                    ></account-register>
                </template>
                <template v-else-if="columnLabel == '通知公告响应率'">
                    <notice-list
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                        :nickName="nickName"
                    ></notice-list>
                </template>
                <template v-else-if="columnLabel == '信息公开率'">
                    <information-open
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                    ></information-open>
                </template>
                <template v-else-if="columnLabel == '人员培训情况'">
                    <train-information
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :orgName='orgName'
                        :eaAreaName='eaAreaName'
                        :objType='objType'
                        :peopleName='peopleName'
                        :phoneNum='phoneNum'
                    ></train-information>
                </template>
                <template v-else-if="columnLabel == '安全检查情况'">
                    <safety-information
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                    ></safety-information>
                </template>
                <template v-else-if="columnLabel == '在管面积㎡'">
                    <manage-project
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                    ></manage-project>
                </template>
                <template v-else-if="columnLabel == '绿色物业' || columnLabel == '幸福小区' || columnLabel == '绿色物业星级评价' || columnLabel == '绿色物业示范项目' || columnLabel == '表彰信息' || columnLabel == '标准编制'">
                    <well-health
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                        :columnLabelType='columnLabelType'
                        :peopleName='peopleName'
                        :certificate='certificate'
                        :keyId='keyId'
                    ></well-health>
                </template>
                <template v-else-if="columnLabel == '责令整改' || columnLabel == '行政处罚' || columnLabel == '法院判决'">
                    <unhealthy
                        :code='code'
                        :columnLabel='columnLabel'
                        :eaAreaCode='eaAreaCode'
                        :objType='objType'
                        :columnLabelType='columnLabelType'
                        :peopleName='peopleName'
                        :certificate='certificate'
                        :keyId='keyId'
                    ></unhealthy>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import satisfaction from './comprehensiveComponents/satisfaction';
import accountRegister from './comprehensiveComponents/accountRegister';
import noticeList from './comprehensiveComponents/noticeList';
import informationOpen from './comprehensiveComponents/informationOpen';
import trainInformation from './comprehensiveComponents/trainInformation';
import safetyInformation from './comprehensiveComponents/safetyInformation';
import manageProject from './comprehensiveComponents/manageProject';
import wellHealth from './comprehensiveComponents/wellHealth';
import unhealthy from './comprehensiveComponents/unhealthy';
export default {
    components: {
        satisfaction,
        accountRegister,
        noticeList,
        informationOpen,
        trainInformation,
        safetyInformation,
        manageProject,
        wellHealth,
        unhealthy
    },
    props: {},
    data() {
        return {
            objType: 1,
            infoType: '1',
            columnLabel: '',
            code: '',
            eaAreaCode: '',
            nickName: '',
            orgName: '',
            eaAreaName: '',
            phoneNum: '',
            columnLabelType: '1',// 良好信息  不良信息 类型 option
            peopleName: '',// 良好信息 不良信息
            certificate: '',// 不良信息  身份证号
            keyId: '',// 良好信息 不良信息
        };
    },
    computed: { ...mapState(['token', 'userInfo']) },
    created() {
        // console.log('=========', this.$route.query);
        this.objType = parseInt(this.$route.query.objType);
        this.infoType = this.$route.query.infoType;
        this.columnLabel = decodeURIComponent(this.$route.query.columnLabel);
        this.code = this.$route.query.code;
        this.eaAreaCode = this.$route.query.eaAreaCode || '';
        this.nickName = decodeURIComponent(this.$route.query.nickName || '');
        this.orgName = decodeURIComponent(this.$route.query.orgName || '');
        this.eaAreaName = decodeURIComponent(this.$route.query.eaAreaName || '');
        this.phoneNum = this.$route.query.phoneNum || ''; // 项目经理phone

        // 良好信息 不良信息
        this.columnLabelType = this.$route.query.columnLabelType || '1';
        this.peopleName = decodeURIComponent(this.$route.query.peopleName || '');
        this.certificate = this.$route.query.certificate || '';
        this.keyId = this.$route.query.keyId || '';
    },
    methods: {
        handleTitle(val) {
            this.objType = val;
            this.$router.push({name: 'InformationManager', query:{objType: this.objType}});
        },
    }
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.comprehensiveList {
//   .el-tabs__content {
//     padding: 0px;
//   }
}
</style>
<style lang="scss" scoped>
.comprehensiveList {
  width: 100%;
  box-sizing: border-box;
  .panel-title {
    display: flex;
    justify-content: space-between;
    .active {
      color: rgb(140,78,127)
    }
    .panel-type {
      width: 18%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: whitesmoke;
      .icon {
        font-size: 25px;
        padding-right: 10px;
      }
      .title {
        font-weight: bold;
      }
    }
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    height: 550px;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 150px);
      .el-table {
        height: 100%;
        overflow: auto;
      }
    }
    .components-box{

    }
  }
}
</style>
